var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50084 15.7743L7.07174 15.1311C7.71955 14.3892 8.30222 13.6852 8.82065 13.0157L9.2486 12.4512C11.0355 10.0436 11.9294 8.13272 11.9294 6.72039C11.9294 3.70572 9.49922 1.26196 6.50084 1.26196C3.50246 1.26196 1.07227 3.70572 1.07227 6.72039C1.07227 8.13272 1.96617 10.0436 3.75308 12.4512L4.18103 13.0157C4.92061 13.9634 5.6944 14.8829 6.50084 15.7743Z",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50019 8.95252C7.7494 8.95252 8.76209 7.93983 8.76209 6.69062C8.76209 5.4414 7.7494 4.42871 6.50019 4.42871C5.25097 4.42871 4.23828 5.4414 4.23828 6.69062C4.23828 7.93983 5.25097 8.95252 6.50019 8.95252Z",
    stroke: "#363636",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector23);
export default __webpack_public_path__ + "static/media/Vector (23).6daeef7228329490f899908f07c3691f.svg";
export { ForwardRef as ReactComponent };